<template>
  <ion-app>
    <!-- Seitliches Menü auf der linken Seite -->
    <ion-menu side="start" content-id="main-content" menu-id="main-menu">
      <ion-header>
        <ion-toolbar color="primary">
          <ion-title>Menü</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-list inset>
          <ion-item @click="navigateTo('Home')">
            <ion-label>Startseite</ion-label>
          </ion-item>
          <ion-item @click="navigateTo('RssPage')">
            <ion-label>RSS</ion-label>
          </ion-item>
          <ion-item @click="navigateTo('Typo3ApiPage')">
            <ion-label>TYPO3-API</ion-label>
          </ion-item>
          <ion-item @click="navigateTo('ImpressumPage')">
            <ion-label>Impressum</ion-label>
          </ion-item>
          <ion-item @click="navigateTo('DatenschutzPage')">
            <ion-label>Datenschutz</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-page id="main-content">
      <!-- Header -->
      <ion-header :translucent="true">
        <ion-toolbar>
          <div class="header-content">
            <!-- Logo auf der linken Seite -->
            <ion-img
                :src="logo"
                alt="Thüringer Staatskanzlei Logo"
                class="logo-img"
                @click="navigateTo('Home')"
            ></ion-img>

            <!-- Seitentitel zentriert -->
            <div class="title">
              <ion-title>{{ pageTitle }}</ion-title>
            </div>

            <!-- Menü-Button auf der rechten Seite -->
            <ion-buttons>
              <ion-menu-button />
            </ion-buttons>
          </div>
        </ion-toolbar>
      </ion-header>

      <!-- Seiteninhalt -->
      <ion-content class="ion-padding">
        <slot />
      </ion-content>

      <!-- Fußzeile -->
      <AppFooter />
    </ion-page>
  </ion-app>
</template>

<script>
// Importiere das Logo und die benötigten Komponenten
import logo from '@/assets/logo-thueringen.svg';
import AppFooter from '@/components/page/Footer.vue';
import {
  IonApp,
  IonHeader,
  IonMenu,
  IonTitle,
  IonToolbar,
  IonContent,
  IonPage,
  IonImg,
  IonButtons,
  IonMenuButton,
  IonList,
  IonItem,
  IonLabel,
} from '@ionic/vue';

export default {
  props: ['pageTitle'],
  name: 'BaseLayout',
  components: {
    IonApp,
    IonHeader,
    IonMenu,
    IonTitle,
    IonToolbar,
    IonContent,
    IonPage,
    IonImg,
    IonButtons,
    IonMenuButton,
    IonList,
    IonItem,
    IonLabel,
    AppFooter,
  },
  data() {
    return {
      logo,
    };
  },
  methods: {
    navigateTo(page) {
      this.$router.push({ name: page });
    },
    resetChat() {
      // Implementiere die Funktion resetChat nach Bedarf
      console.log('Chat zurückgesetzt');
    },
  },
};
</script>

<style scoped>
ion-page {
  height: 100%;
}

ion-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.logo-img {
  max-width: 160px;
  cursor: pointer;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.title {
  flex: 1;
  text-align: center;
}

.title ion-title {
  margin: 0; /* Entfernt den Standard-Margin */
}

/* Platzhalter für Symmetrie, falls benötigt */
.right-placeholder {
  width: 40px; /* Gleiche Breite wie der Menü-Button */
}

/* Optional: Responsive Anpassungen */
@media (max-width: 600px) {
  .logo-img {
    margin-left: 4px;
  }

  .title ion-title {
    font-size: 1.2em;
  }

  .right-placeholder {
    width: 30px; /* Anpassung der Breite des Platzhalters */
  }
}
</style>
